import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { createSelector } from 'reselect';

import { LibraryCourseContainerWidgetStore } from './typings';

const courseContainerWidgetStateSelector = (storeState: any): LibraryCourseContainerWidgetStore =>
    storeState.courseContainerWidget;

export const isLinkCourseContainerToCourseLoading = createSelector(
    [courseContainerWidgetStateSelector],
    (state: LibraryCourseContainerWidgetStore): boolean =>
        state.linkCourseContainerToCourseLoadingStatus === LOADING_STATUSES.LOADING
);
